// 引入createStore创建store，引入applyMiddleware 来使用中间件
import { createStore } from 'redux';
// 引入所有的reducer
import reducer from './../reducer';

const initialState = {
    artName:'首页',
    headName:'首页',
    isShow:true,
    showMsg:true,
    isReg:false
};
const configureStore = () => createStore(reducer,initialState);

export default configureStore;